import { render, staticRenderFns } from "./MySchool.vue?vue&type=template&id=43438043&scoped=true"
import script from "./MySchool.vue?vue&type=script&lang=ts"
export * from "./MySchool.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43438043",
  null
  
)

export default component.exports